// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1352 ? "e56534df" : chunkId) + "." + {"1352":"794c37a07c523e0a","2179":"44ef466188141b07","7242":"9cfab5e3af3b8e15"}[chunkId] + ".js";
};